import { isEmpty } from "lodash";

async function getToken(uid: string): Promise<string | undefined> {
  try {
    const data = await window.fetch(`${process.env.REACT_APP_API_GATEWAY_URL}/users/auth-tokens/${uid}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    })

    const d = await data.json();
    
    if (d.data.token && !isEmpty(d.data.token)) {
      return d.data.token;
    }

    return undefined;
  } catch (error) {
    console.log(error);
  }
}

export default getToken;
